angular.module('leanlaw').controller('ClientOverviewCtrl', ['$state', '$scope', '$stateParams', function ($state, $scope, $stateParams) {
  if (!$scope.me.permissions.matters.overview) {
    $state.go('clients.client.view.info', {
      id: $stateParams.id
    });
  }
  $scope.vm = {
    clientId: $stateParams.id,
    module: $scope.module
  };
}]);